var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.31229 1.08856e-07C1.48468 -6.29991e-05 1.6554 0.0273141 1.81469 0.0805676C1.97398 0.133821 2.11873 0.211908 2.24067 0.310368L10.1848 6.73407C10.7581 7.19859 11.0801 7.82784 11.0801 8.48387C11.0801 9.13989 10.7581 9.76915 10.1848 10.2337L2.23892 16.6574C1.99045 16.847 1.66024 16.9508 1.3185 16.9468C0.976754 16.9428 0.650439 16.8312 0.408936 16.6358C0.167433 16.4404 0.0297934 16.1765 0.0252845 15.9004C0.0207745 15.6243 0.149752 15.3576 0.38479 15.1571L8.33504 8.73414C8.41706 8.66785 8.46313 8.57795 8.46313 8.48422C8.46313 8.39049 8.41706 8.30059 8.33504 8.2343L0.38479 1.8106C0.201166 1.66233 0.0760848 1.47339 0.0253646 1.26768C-0.0253556 1.06197 0.000563328 0.848724 0.0998437 0.654916C0.199124 0.461107 0.367307 0.29544 0.583122 0.178865C0.798937 0.0622906 1.05269 4.48843e-05 1.31229 1.08856e-07Z",
    fill: "#B0AFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/RightArrow.3bf5ff55be496269ee9ca2fa9a8884f4.svg";
export { ForwardRef as ReactComponent };